import { setupForDark } from '@theme';
import classNames from 'classnames';

export default function GoalCardOrderedLabel({ orderedLabel }: { orderedLabel: number }) {
  return (
    <div
      className={classNames(
        'flex items-center justify-center min-w-[24px] self-stretch rounded-l-md',
        setupForDark('bg-tertiary text-white')
      )}
    >
      {orderedLabel}
    </div>
  );
}
